import type { ReactElement } from 'react';
import { EndpointDetailsPopover } from '@/components/Inventory/EndpointDetailsPopover';

/**
 * One endpoint: its name (falling back to the ID) with the details popover.
 * Shows the raw ID only while endpoint names are switched off for the org.
 */
export function EndpointCell({
  userId,
  machineId,
  endpointName,
  showName,
}: {
  userId: string;
  machineId: string;
  endpointName?: string | null;
  showName: boolean;
}): ReactElement {
  if (!showName) {
    return (
      <span className="block truncate font-mono text-xs" title={machineId}>
        {machineId}
      </span>
    );
  }
  return (
    <EndpointDetailsPopover
      userId={userId}
      machineId={machineId}
      endpointName={endpointName}
      triggerClassName="max-w-full"
    />
  );
}
